import { DSTooltip, TAB_TYPE } from '@repo/design-system/index'
import { QIcon_outlink } from '@repo/icons/index'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import 'react-reflex/styles.css'
import { useEventTracking } from '../../../../helpers/gtmHelper'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import { n_classroom, n_lesson_prep } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { PREP_TABS, TAB } from '../../../materials/const'
import { getUserSetting } from '../../review/DocNoteTabPanel'

interface SubTabProps {
  SUB_MENU_LIST: any
  activeTabIdx: any
  setActiveTabIdx: any
  type: any
  lesson: any
  currentUser: any
  isRightTab: any
  saveMoveSubTab?: any
  isEditable?: any
  setIsEditable?: any
  activeQuestionId?: any
  answer?: any
}

const SubTab = ({
  SUB_MENU_LIST,
  activeTabIdx,
  setActiveTabIdx,
  type,
  lesson,
  currentUser,
  isRightTab = true,
  saveMoveSubTab,
  isEditable,
  setIsEditable,
  activeQuestionId,
  answer,
}: SubTabProps) => {
  const { t } = useTranslation()
  const isWebview = useIsWebview()
  const { sendClickEvent } = useEventTracking()

  const token = lesson?.ringledoc
  const [seesionRole, setSessionRole] = useState('tutor')
  const [username, setUsername] = useState('Anonymous')

  const questionCnt = lesson?.duration == 20 ? 2 : 3
  const tooltipContent = t(n_lesson_prep.overview.tooltip_done(questionCnt))

  useEffect(() => {
    const { session_role, username, domain } = getUserSetting(currentUser)
    setUsername(username)
    setSessionRole(session_role)
  }, [])

  return (
    <div className="z-60 top-[70px] left-[0px] h-[52px] cursor-pointer bg-white px-[20px] shadow-sm">
      <div className="mx-0 flex">
        <div className="no-scrollbar flex w-full justify-center">
          <div
            className={classNames(
              'bg-q-white border-q-gray-100 flex h-[52px] w-full flex-row justify-evenly sm:justify-start'
              // type === TAB_TYPE.SCROLL ? 'justify-start ' : 'justify-evenly sm:justify-center'
            )}
          >
            {SUB_MENU_LIST.filter((item) => item.none != true).map((item, idx) => (
              <>
                <div
                  key={idx}
                  className={classNames(
                    'mb-[-1px] min-w-fit py-[13px] px-[8px]',
                    item.key === activeTabIdx
                      ? 'border-b-[2px] border-black text-black '
                      : 'cursor-pointer text-gray-300',
                    type === TAB_TYPE.SCROLL ? 'mx-[8px]' : 'mx-0 sm:mx-[68px] '
                  )}
                  onClick={() => {
                    if (item.key !== activeTabIdx && setActiveTabIdx) {
                      setActiveTabIdx(item.key)
                      saveMoveSubTab &&
                        isEditable &&
                        setIsEditable &&
                        activeQuestionId &&
                        answer &&
                        saveMoveSubTab({ isEditable, setIsEditable, activeQuestionId, answer, lesson })
                    }

                    // click event
                    let object_title
                    switch (item.key) {
                      case TAB.QUESTION_SELECT:
                        object_title = PREP_TABS.QUESTION
                        break
                      case TAB.NOTE:
                        object_title = PREP_TABS.NOTE
                        break
                      default:
                        break
                    }
                    sendClickEvent({ button_name: 'lesson_prep_tab', object_title })
                  }}
                >
                  {isWebview && item.key === TAB.QUESTION_SELECT ? (
                    <DSTooltip
                      place={'bottom'}
                      triggerComponent={
                        <div
                          className={classNames(
                            typeof item.label !== 'object' && 'Body1-16Bd leading-[26px]',
                            'flex items-center justify-center'
                          )}
                        >
                          {item.label}
                        </div>
                      }
                      contentComponent={tooltipContent}
                      hasCloseButton
                    />
                  ) : (
                    <div
                      className={classNames(
                        typeof item.label !== 'object' && 'Body1-16Bd leading-[26px]',
                        'flex items-center justify-center'
                      )}
                    >
                      {item.label}
                    </div>
                  )}
                </div>
              </>
            ))}
          </div>
          {isRightTab && (
            <div
              className="relative right-[0px] top-[15px]"
              onClick={() => sendClickEvent({ button_name: 'lesson_note' })}
            >
              <a
                href={
                  lesson?.ringledoc_url
                    ? `${lesson?.ringledoc_url}?token=${token}&role=${seesionRole}&username=${username}`
                    : lesson?.document_url
                }
                target="_blank"
                rel="noreferrer"
                className="hidden sm:flex sm:min-w-[150px]"
              >
                <div className="flex items-center justify-center gap-x-8">
                  <QIcon_outlink width={'20px'} height={'20px'} />
                  <span className="text-14 font-medium">{t(n_classroom.tab_note_newtab)}</span>
                </div>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SubTab
